import React, { useState, useEffect } from 'react';
import { Save } from 'lucide-react';
import { getConfig, updateConfig } from '../services/api';

const Config = () => {
  const [config, setConfig] = useState({ default_snapshot_interval: '60', snapshot_retention_days: '30', ehome_key: '' });
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => { loadConfig(); }, []);

  const loadConfig = async () => {
    try {
      const res = await getConfig();
      setConfig(res.data);
    } catch (err) { console.error('Error loading config:', err); }
  };

  const handleSave = async () => {
    setSaving(true);
    setMessage('');
    try {
      await updateConfig({
        default_snapshot_interval: parseInt(config.default_snapshot_interval),
        snapshot_retention_days: parseInt(config.snapshot_retention_days)
      });
      setMessage('Configuración guardada');
      setTimeout(() => setMessage(''), 3000);
    } catch (err) { setMessage('Error guardando configuración'); }
    finally { setSaving(false); }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Configuración</h1>
      <div style={styles.card}>
        <h2 style={styles.cardTitle}>Configuración Global</h2>
        <div style={styles.formGroup}>
          <label style={styles.label}>Intervalo de snapshot por defecto (segundos)</label>
          <input type="number" value={config.default_snapshot_interval}
            onChange={(e) => setConfig({...config, default_snapshot_interval: e.target.value})}
            style={styles.input} min="10" />
          <p style={styles.hint}>Se aplicará a nuevos dispositivos registrados</p>
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>Retención de snapshots (días)</label>
          <input type="number" value={config.snapshot_retention_days}
            onChange={(e) => setConfig({...config, snapshot_retention_days: e.target.value})}
            style={styles.input} min="1" />
          <p style={styles.hint}>Los snapshots más antiguos se eliminarán automáticamente a las 3am</p>
        </div>
        {message && <div style={message.includes('Error') ? styles.error : styles.success}>{message}</div>}
        <button onClick={handleSave} style={styles.saveBtn} disabled={saving}>
          <Save size={18} />{saving ? 'Guardando...' : 'Guardar Cambios'}</button>
      </div>
      <div style={styles.card}>
        <h2 style={styles.cardTitle}>API Externa (Estilo Samsara)</h2>
        <p style={styles.hint}>Endpoints para integración sin autenticación:</p>
        <div style={styles.apiExample}>
          <code>GET /external/v1/fleet/vehicles/{'{device_id}'}/snapshot?channel=1</code>
          <p>Retorna imagen JPEG directamente</p>
        </div>
        <div style={styles.apiExample}>
          <code>GET /external/v1/fleet/vehicles/{'{device_id}'}/snapshot/json?channel=1</code>
          <p>Retorna JSON con imagen en base64</p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: { padding: '24px', maxWidth: '800px', margin: '0 auto' },
  title: { fontSize: '24px', fontWeight: 'bold', marginBottom: '24px' },
  card: { background: 'white', borderRadius: '12px', padding: '24px', marginBottom: '24px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' },
  cardTitle: { fontSize: '18px', fontWeight: '600', marginBottom: '20px', paddingBottom: '12px', borderBottom: '1px solid #e5e7eb' },
  formGroup: { marginBottom: '20px' },
  label: { display: 'block', fontWeight: '500', marginBottom: '6px', color: '#374151' },
  input: { width: '100%', padding: '10px 12px', border: '1px solid #e5e7eb', borderRadius: '6px', fontSize: '14px' },
  hint: { color: '#6b7280', fontSize: '13px', marginTop: '4px' },
  saveBtn: { display: 'flex', alignItems: 'center', gap: '8px', padding: '12px 24px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '8px', fontWeight: '500', cursor: 'pointer' },
  success: { background: '#d1fae5', color: '#065f46', padding: '12px', borderRadius: '8px', marginBottom: '16px' },
  error: { background: '#fef2f2', color: '#dc2626', padding: '12px', borderRadius: '8px', marginBottom: '16px' },
  apiExample: { background: '#f9fafb', padding: '16px', borderRadius: '8px', marginBottom: '12px' },
};

export default Config;
